import { faPlus } from '@fortawesome/pro-regular-svg-icons'
import Link from 'next/link'
import { Icon } from 'ui'

export default function CartAddAnotherProduct() {
	return (
		<Link href="/products" className="button button-dark">
			<Icon icon={faPlus} className="mr-2 mb-1" />
			Add another product
		</Link>
	)
}
